export const LOW_COUNT_FLOOR = 3;
export const COUNT_CEILING = 99;

export const toCount = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
};

export const describeViewerCount = (value) => {
  const n = toCount(value);
  if (n < LOW_COUNT_FLOOR) return "Someone";
  return n > COUNT_CEILING ? `${COUNT_CEILING}+ people` : `${n} people`;
};
